import React, {
  createContext,
  useState,
  useEffect,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const LastLocationContext = createContext();
export const LastLocationProvider = ({ children }) => {
  const [lastLocation, setLastLocation] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setLastLocation(location);
  }, [location]);

  return (
    <LastLocationContext.Provider value={lastLocation}>
      {children}
    </LastLocationContext.Provider>
  );
};

LastLocationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useLastLocation = () => useContext(LastLocationContext);
